module.exports = __webpack_public_path__ + "static/media/bogo_card_2.cb89434c.jpg";